// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__X5ugh","poweredBy":"Footer_poweredBy__sQc56","logo":"Footer_logo__zGfFO","links":"Footer_links__aGZsp","link":"Footer_link__3L-YQ","dot":"Footer_dot__ikCUG"};